export type PhoneStatus =
  | "dialing_clinic"
  | "dialing_clinic_failed"
  | "dialing_patient"
  | "dialing_patient_failed"
  | "call_connected"
  | "call_ended"
  | "call_failed"
  | "recording_ready"
  | "recording_failed"
  | "timeout"
  | "idle"
  | "unknown";

export function isPhoneError(status: PhoneStatus): boolean {
  return [
    "dialing_clinic_failed",
    "dialing_patient_failed",
    "call_failed",
    "recording_failed",
    "timeout",
    "unknown",
  ].includes(status);
}

export function isPhoneSuccess(status: PhoneStatus): boolean {
  return status === "recording_ready";
}

export function isPhoneComplete(status: PhoneStatus): boolean {
  return isPhoneSuccess(status) || isPhoneError(status) || status === "idle";
}

export function isPhoneInProgress(status: PhoneStatus): boolean {
  return [
    "dialing_clinic",
    "dialing_patient",
    "call_connected",
    "call_ended",
  ].includes(status);
}

export function isPhoneStatus(value: unknown): value is PhoneStatus {
  return (
    typeof value === "string" &&
    (isPhoneComplete(value as PhoneStatus) ||
      isPhoneInProgress(value as PhoneStatus))
  );
}
